import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t, lang, toggleLang } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-[#1C1917] text-stone-300 mt-24 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-5">
            <img
              src="https://customer-assets.emergentagent.com/job_gsm-service-hub-2/artifacts/2b7tqu2l_D%C3%A9m%C3%A9nagement%20%20Am%C3%A9nagement%20R%C3%A9sidentiel%20Commercial%20%20Industriel%20Nettoyage%20apr%C3%A8s%20construction%20Sous-%20traitance%20accept%C3%A9%20%284%29.png"
              alt="GSM"
              className="w-16 h-16 object-contain bg-white rounded-md p-1.5"
            />
            <div>
              <div className="font-serif text-2xl text-white">GSM Service Maintenance</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-stone-500 font-mono">Laval · Québec</div>
            </div>
          </div>
          <p className="font-serif italic text-2xl text-stone-100 max-w-md leading-snug">
            « {t("footer.tagline")} »
          </p>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-stone-500 font-mono mb-4">{t("nav.contact")}</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-[#B95736]" /><a href="tel:+15146250359" className="hover:text-white transition-colors" data-testid="footer-phone">514-625-0359</a></li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-[#B95736]" /><a href="mailto:gsmservicedemaintenance@gmail.com" className="hover:text-white transition-colors break-all" data-testid="footer-email">gsmservicedemaintenance@gmail.com</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-[#B95736]" /><span>{t("contact.area.value")}</span></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-stone-500 font-mono mb-4">Navigation</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white transition-colors">{t("nav.services")}</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">{t("nav.quote")}</Link></li>
            <li><Link to="/admin" className="text-stone-500 hover:text-stone-300 transition-colors text-xs" data-testid="footer-admin-link">{t("nav.admin")}</Link></li>
          </ul>
          <button
            data-testid="footer-lang-toggle"
            onClick={toggleLang}
            className="mt-6 text-xs font-mono tracking-widest border border-stone-700 rounded-full px-3 py-1.5 text-stone-400 hover:text-white hover:border-stone-500 transition-colors"
          >
            <span className={lang === "fr" ? "text-[#B95736]" : ""}>FR</span>
            <span className="text-stone-600 mx-1">/</span>
            <span className={lang === "en" ? "text-[#B95736]" : ""}>EN</span>
          </button>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-500 font-mono">
          <div>© {new Date().getFullYear()} GSM Service Maintenance — {t("footer.rights")}</div>
          <div>Laval · Québec · Canada</div>
        </div>
      </div>
    </footer>
  );
}
